module.exports = __webpack_public_path__ + "static/media/reading-second-icon.27b2dbd5.svg";